import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule, PoNotificationModule } from '@po-ui/ng-components';
import { AccountGeneralDataComponent } from './account-general-data/account-general-data.component';
import { AddressComponent } from './address/address.component';
import { ContactComponent } from './contact/contact.component';

@NgModule({
  declarations: [
    AccountGeneralDataComponent,
    AddressComponent,
    ContactComponent
  ],
  imports: [
    CommonModule,
    PoModule,
    PoNotificationModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    AccountGeneralDataComponent,
    AddressComponent,
    ContactComponent
  ]
})
export class AccountModule { }
